// Plugin global para sistema de alertas
let globalAlertSystem = null;

export const AlertPlugin = {
    install(app) {
        // Método global para registrar o sistema de alertas
        app.config.globalProperties.$registerAlertSystem = (alertSystemInstance) => {
            globalAlertSystem = alertSystemInstance;
            console.log('AlertSystem registrado globalmente');
        };

        // Método global para mostrar alertas
        app.config.globalProperties.$showAlert = (message, type = 'info', duration = 5000) => {
            console.log('=== $showAlert CHAMADO ===');
            console.log('Mensagem:', message);
            console.log('Tipo:', type);
            console.log('GlobalAlertSystem disponível:', !!globalAlertSystem);

            if (globalAlertSystem) {
                globalAlertSystem.showAlert(message, type, duration);
            } else {
                console.warn('AlertSystem não está registrado. Usando alert nativo.');
                alert(`${type.toUpperCase()}: ${message}`);
            }
        };

        // Método para obter a instância do AlertSystem
        app.config.globalProperties.$getAlertSystem = () => {
            return globalAlertSystem;
        };
    }
};

// Exportar função para uso direto (fora de componentes Vue)
export const showGlobalAlert = (message, type = 'info', duration = 5000) => {
    if (globalAlertSystem) {
        globalAlertSystem.showAlert(message, type, duration);
    } else {
        console.warn('AlertSystem não está registrado.');
        alert(`${type.toUpperCase()}: ${message}`);
    }
};
